<template>
  <div>
    <div>
      <div
        style="z-index: 2000"
        class="absolute top-4 left-4"
        @click="open = !open"
      >
        <img
          :src="require(`@/assets/images/languages/${selected.src}`)"
          :alt="selected.label"
          class="w-14"
        />
      </div>
      <button
        v-if="open"
        style="z-index: 2000"
        class="absolute top-4 right-4"
        @click="open = false"
      >
        <img src="../assets/images/close_btn.png" alt="close" class="w-8" />
      </button>
      <ul
        v-if="open"
        style="z-index: 2000"
        class="absolute top-1/2 left-1/2 w-9/12 languages"
      >
        <div class="bg-white py-2">
          <p class="text-center text-2xl">언어 선택</p>
          <p class="text-center text-sm font-light">Select a Language</p>
        </div>
        <li
          v-for="lang in langs"
          :key="lang.code"
          @click="onLocaleChange(lang)"
          class="flex items-center language text-lg pl-12 py-2"
          :class="{ active: selected.label == lang.label }"
        >
          <img
            :src="require(`@/assets/images/languages/${lang.src}`)"
            :alt="lang.label"
            class="w-14"
          />
          <p class="ml-6">{{ lang.label }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      langs: [
        {
          code: "ko",
          label: "한국어",
          src: "korean.png",
        },
        {
          code: "zh",
          label: "中文",
          src: "chinese.png",
        },
        {
          code: "ja",
          label: "日本語",
          src: "japanese.png",
        },
        {
          code: "en",
          label: "English",
          src: "english.png",
        },
        {
          code: "child",
          label: "어린이용(한국어)",
          src: "korean-child.png",
        },
      ],
      selected: {
        code: "ko",
        label: "한국어",
        src: "korean.png",
      },
      open: false,
    };
  },
  created() {
    if (this.$store.getters.getLocale) {
      this.selected = this.$store.getters.getLocale;
    }
  },
  methods: {
    onLocaleChange(lang) {
      this.$store.commit("saveLocale", lang);
      this.$i18n.locale = lang.code;
      this.open = false;
      this.selected = lang;
    },
  },
};
</script>

<style scoped>
.languages {
  border: solid 1px #fff;
  border-radius: 0.25rem;
  overflow: hidden;
  transform: translate(-50%, -50%);
}
.language {
  background: rgba(255, 255, 255, 0.6);
  position: relative;
}
.language.active {
  background: rgba(228, 201, 120, 0.8);
}
.language:last-child::after {
  display: none;
}
.language::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 70%;
  height: 1px;
  background: #888;
}
</style>
